import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, transferenciaPropietario } from './types';

export const INITIAL_STATE: transferenciaPropietario = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): transferenciaPropietario {
	return produce(state, draft => {
		switch (action.type) {
			case Types.TRANSFERENCIA_PROPRIETARIO_REQUEST: {
				break;
			}

			case Types.TRANSFERENCIA_PROPRIETARIO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.TRANSFERENCIA_PROPRIETARIO_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			default:
		}
		return draft;
	});
}
